var _ellipse, _ellipse2, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarF1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 107,
    viewBox: "0 0 108 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 54.0047,
    ry: 53.5,
    transform: "matrix(-1 0 0 1 54.0048 53.5)",
    fill: "#00B0EF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_613_758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 109,
    height: 107
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 54.0047,
    ry: 53.5,
    transform: "matrix(-1 0 0 1 54.0048 53.5)",
    fill: "#00B0EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_613_758)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 144,
    transform: "matrix(-1 0 0 1 130 -17)",
    fill: "#B6EDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6699 -3.02832H-14.132V43.4056H55.6699C64.5065 43.4056 71.6699 36.2422 71.6699 27.4056V-3.02832Z",
    fill: "#B5EDFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.349 82.7736C28.9865 82.7736 22.2075 75.5425 22.2075 66.6226H52.4905C52.4905 75.5425 45.7114 82.7736 37.349 82.7736Z",
    fill: "#087CDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8773 56.5283C93.8773 64.8908 86.6462 71.6699 77.7263 71.6699L77.7263 41.3868C86.6462 41.3868 93.8773 48.1659 93.8773 56.5283Z",
    fill: "#00B0EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarF1);
export default __webpack_public_path__ + "static/media/avatarF1.cd5bf212451c1c983ef8cb5452a12e29.svg";
export { ForwardRef as ReactComponent };